import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/students')({
  component: RouteComponent,
  loader: () => ({
    crumb: 'Students',
  }),
});

function RouteComponent() {
  return <Outlet />;
}
